import authInstance from 'config/axios.config';

export const authServices = {
  changePassword: async (payload) => {
    const res = await authInstance.patch('/admin/profile/change-password', payload);
    return res.data;
  },

  userProfile: async () => {
    const res = await authInstance.get('/admin/profile');
    return res.data;
  },

  updateProfile: async (payload) => {
    const res = await authInstance.patch('/admin/profile', payload);
    return res.data;
  },

  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await authInstance.post('/admin/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  },

  updateProfilePhoto: async (adminId, profilePhotoKey) => {
    const res = await authInstance.patch(`/admin/${adminId}`, {
      profilePhoto: profilePhotoKey,
    });
    return res.data;
  },

  deleteProfilePhoto: async (adminId) => {
    const res = await authInstance.patch(`/admin/${adminId}`, {
      profilePhoto: null,
    });
    return res.data;
  },
};
